// Shared browser-side constants and helpers for talking to the portal.
//
// Duplicated deliberately from src/server/http.ts rather than imported: the client
// bundle must not pull in server code (and its Node imports). These are a handful
// of string constants; the alternative is a shared module that exists only to hold
// them.

export const CSRF_COOKIE = 'tnd_web_csrf'
export const CSRF_HEADER = 'x-tendally-csrf'
/** Forces a CORS preflight the server never grants, so a cross-site form cannot post. */
export const CLIENT_HEADER = 'x-tendally-web'

export function readCookie(name: string): string | null {
  const prefix = `${name}=`
  for (const part of document.cookie.split('; ')) {
    if (part.startsWith(prefix)) return decodeURIComponent(part.slice(prefix.length))
  }
  return null
}

export interface WebError {
  code: string
  message: string
  details?: unknown
}

export type WebResult<T> = { ok: true; data: T } | { ok: false; error: WebError }

/** Calls one of the /auth/web/* endpoints, which sit outside the IPC contract. */
export async function webAuth<T>(op: string, body: unknown = {}): Promise<WebResult<T>> {
  const res = await fetch(`/auth/web/${op}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      [CLIENT_HEADER]: '1',
      [CSRF_HEADER]: readCookie(CSRF_COOKIE) ?? ''
    },
    body: JSON.stringify(body)
  })
  if (!res.ok) {
    return { ok: false, error: { code: 'NETWORK', message: `Network error (${res.status})` } }
  }
  return (await res.json()) as WebResult<T>
}
